








import { Component, Prop, Vue } from 'vue-property-decorator';
import { CommandReturn } from '../../cablin/commands';
import ExprComp from '../expr/Expr.vue';

@Component({
  components: {
    ExprComp,
  }
})
export default class CommandReturnComp extends Vue {
  @Prop() private cmd!: CommandReturn
}
